module.exports = __webpack_public_path__ + "static/media/star-grey.d5afd6db.svg";